<!-- TODO: Refactor it. -->

<template>
  <f7-page class="settings-sync-contracts">
    <f7-navbar :title="$t('userConfiguration.contracts.sync.page.title')">
      <f7-nav-right>
        <f7-link
          popup-close
          @click="NavigateBack()"
        >
          <img :src="icClose">
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-list class="no-padding padding-vertical-half content-sync-info">
      <f7-list-item :title="$t('userConfiguration.contracts.sync.page.lastSync')">
        <template #after-title>
          <div class="after-title">
            {{ lastSync }}
          </div>
        </template>

        <template #after>
          <div>
            <f7-button
              :disabled="pendingTaskCount === 0"
              small
              fill
              color="green"
              class="button-large"
              @click="retryAllFailures"
            >
              {{ $t('common.syncUp') }}
            </f7-button>
          </div>
        </template>
      </f7-list-item>
    </f7-list>

    <div class="main-settings__title padding">
      {{ $t('common.information') }}
    </div>
    <UCPreload :show="loading" />
    <div
      v-if="!loading"
      style="height: 77%; width: 100%;"
    >
      <UCAcordeon
        :items="tasksSync"
        item-title="name"
        class="sorted-accordion-list"
        :show-badge="false"
        primary="#fff"
        secondary="var(--his-slate-blue)"
        font-color="#484848"
        :show-item-border-bottom="true"
        border-item-bottom-color="#E5EEF7"
        chevron-side="left"
        :closed="true"
        :show-checkbox="false"
        @click-item-event="SelectItem"
      >
        <template #after="{ item }">
          <img
            v-if="item.status === 'ok'"
            :src="icCheck"
            width="22"
            height="22"
          >
          <img
            v-else-if="item.status === 'ko'"
            :src="icError"
            width="22"
            height="22"
          >
          <f7-preloader
            v-else-if="item.status === 'sync'"
            :size="18"
            color="orange"
          />
        </template>

        <template #item-option-title="{ item, itemOption }">
          <div>
            <!-- Info. Contratos -->
            <div v-if="item.key === 'contracts'">
              <span style="font-weight: bold;">{{ `${$t('common.farmer')}:` }}</span>
              <span> {{ itemOption.field.farmer.name }} </span>
              <br>
              <span style="font-weight: bold;">{{ $t('userConfiguration.contracts.sync.page.contract.field') }}</span>
              <span> {{ itemOption.field.name }} </span>
              <br>
              <span style="font-weight: bold;">{{ `${$t('common.date')}:` }}</span>
              <span>{{ `${FormatDate(itemOption.startDate)} - ${FormatDate(itemOption.endDate)}` }}</span>
            </div>
            <!-- Info. Cultivos -->
            <div v-else-if="item.key === 'crops'">
              <span style="font-weight: bold;">{{ `${$t('common.farmer')}:` }}</span>
              <span> {{ itemOption.field.farmer.name }} </span>
              <br>
              <span style="font-weight: bold;">{{ $t('userConfiguration.contracts.sync.page.contract.field') }}</span>
              <span> {{ itemOption.field.name }} </span>
            </div>
            <!-- Info. Fincas -->
            <div v-else-if="item.key === 'fields'">
              <span style="font-weight: bold;">{{ `${$t('common.farmer')}:` }}</span>
              <span> {{ itemOption.farmer.name }} </span>
              <br>
              <span style="font-weight: bold;">{{ $t('userConfiguration.contracts.sync.page.contract.field') }}</span>
              <span> {{ itemOption.name }} </span>
            </div>
            <!-- Info. Default -->
            <div v-else-if="itemOption.hasOwnProperty('name')">
              {{ itemOption.name }}
            </div>
          </div>
        </template>
        <template #subOption="{ item }">
          <div v-if="item != null">
            <div v-if="item.hasOwnProperty('sync_error_msg')">
              {{
                item.sync_error_msg !== '' ? item.sync_error_msg
                : item.sync_status === 2
                  ? $t('userConfiguration.contracts.sync.page.contract.status.deleted')
                  : $t('userConfiguration.contracts.sync.page.contract.status.modified')
              }}
            </div>
            <div v-else-if="!item.hasOwnProperty('sync_error_msg')">
              {{ $t('userConfiguration.contracts.sync.page.contract.status.pending') }}
            </div>
          </div>
        </template>
      </UCAcordeon>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useContractsStore } from '@/js/stores/contracts';

import SyncData from '@/js/services/contracts/SyncData';

import icError from '@/static/img/ic_error.svg';
import icCheck from '@/static/img/ic_check_clean.svg';
import icClose from '@/static/icons/ic_close.svg';

import UCPreload from '@/components/common/UCPreload.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import { HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import { formatDate } from '@/js/utils/date';

export default {
  name: 'FrmSettingsSyncContracts',

  components: {
    UCAcordeon,
    UCPreload,
  },

  data() {
    return {
      tasksSync: [],
      icClose,
      icError,
      icCheck,
      loading: false,
    };
  },

  computed: {
    ...mapState(useContractsStore, [
      'lastSyncMasterData',
      'lastSyncEntities',
    ]),

    lastSync() {
      let time = '';
      time = this.lastSyncMasterData < this.lastSyncEntities
        ? this.lastSyncMasterData
        : this.lastSyncEntities;
      const timeFormats = [
        [60, 'segundos', 1], // 60
        [120, 'hace 1 minuto', 'dentro de 1 minuto'], // 60*2
        [3600, 'minutos', 60], // 60*60, 60
        [7200, 'hace 1 hora', 'dentro de una hora'], // 60*60*2
        [86400, 'horas', 3600], // 60*60*24, 60*60
        [172800, 'ayer', 'Mañana'], // 60*60*24*2
        [604800, 'días', 86400], // 60*60*24*7, 60*60*24
        [1209600, 'hace 1 semana', 'la semana que viene'], // 60*60*24*7*4*2
        [2419200, 'semanas', 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, 'hace 1 mes', 'el mes que viene'], // 60*60*24*7*4*2
        [29030400, 'meses', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, 'hace 1 año', 'el año que viene'], // 60*60*24*7*4*12*2
        [2903040000, 'años', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
        [58060800000, 'centuries', 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
      ];
      const lastTime = new Date(time);
      let seconds = Math.floor((new Date() - lastTime) / 1000);
      let token = 'hace';
      let listChoice = 1;

      if (seconds === 0) {
        return 'Ahora mismo';
      }
      if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = 'dentro de';
        listChoice = 2;
      }
      let i = 0;
      let format = timeFormats[i];
      while (format) {
        if (seconds < format[0]) {
          if (typeof format[2] === 'string') {
            return format[listChoice];
          }
          return `${token} ${Math.floor(seconds / format[2])} ${format[1]}`;
        }
        i += 1;
        format = timeFormats[i];
      }
      return time;
    },
    pendingTaskCount() {
      return this.tasksSync.filter((f) => f.status === 'ko').length;
    },
  },

  created() {
    this.InitPage();
  },

  methods: {
    NavigateBack() {
      f7.views.main.router.back();
    },
    async retryAllFailures() {
      this.tasksSync.forEach((element) => {
        element.status = 'sync';
      });
      await SyncData.ForceSync(true);
      this.InitPage();
    },

    SelectItem(option, item) {
      if (item.sync_status === 2) {
        const alertText = this.$t('userConfiguration.contracts.page.selectionAlert.syncPending.text');
        HiNotification.Alert(alertText);
        return;
      }
      switch (option.key) {
        case 'crops':

          f7.views.main.router.navigate('/new-crop/', {
            props: {
              cropId: Number.parseInt(item.id, 10),
              fieldId: Number.parseInt(item.field.id, 10),
            },
          });
          break;
        case 'contracts':
          f7.views.main.router.navigate('/new-contract/', {
            props: {
              contractId: Number.parseInt(item.id, 10),
            },
          });
          break;
        case 'fields':
          f7.views.main.router.navigate('/new-field/', {
            props: {
              farmerId: Number.parseInt(item.farmer.id, 10),
              fieldId: Number.parseInt(item.id, 10),
            },
          });
          break;
        default:
          break;
      }
    },

    FormatDate(date) {
      return formatDate(date, 'DD/MM/YYYY');
    },

    async InitPage() {
      this.loading = true;
      this.tasksSync = await SyncData.GetTasksSync();
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.settings-sync-contracts {
  :deep(.sorted-accordion-list) {
    &.storybook-action-sorted-accordion {
      .accordion-list {
        .sorted-accordion {
          .item-after {
            background-color: var(--his-bg) !important;
            transition-property: background-color;
          }
        }
      }
    }

    .storybook-action-sorted-accordion-content {
      .list {
        ul {
          li:first-child {
            .item-inner {
              padding-top: 0;
            }
          }
        }
      }
    }

    .accordion-list .accordion-item-opened > .item-inner > ::after {
      border: 0 !important;
    }
  }

  :deep(.content-sync-info) {
    .item-title {
      color: var(--his-oliva);
      font-size: 14px;
      font-weight: 400;
    }

    .after-title {
      color: var(--his-dark-blue);
      font-size: 14px;
      font-weight: 500;
      margin-left: 3px;
    }
  }
}
</style>
